import { render, staticRenderFns } from "./Func47888Perfil.vue?vue&type=template&id=36b6c8c0"
import script from "./Func47888Perfil.vue?vue&type=script&lang=js"
export * from "./Func47888Perfil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports